export default __webpack_public_path__ + "static/logo a11y_-13efc2d2139a749df723427fb69bed19.png";